// extracted by mini-css-extract-plugin
module.exports = {"fav_page":"style_fav_page__2j5hh","favorite_container":"style_favorite_container__2RTIL","favorite__tracks":"style_favorite__tracks__3zcIs"};